/* Qorbell : affiche la 2e image du produit au survol de la vignette.
   Le theme passe l'URL de la 2e image dans data-product-options.image2
   mais ne l'affiche que si l'effet de survol est "Opacity". On l'injecte nous-memes. */
(function () {
  'use strict';

  function bigger(url) {
    if (!url) return null;
    var u = String(url);
    if (u.indexOf('//') === 0) u = 'https:' + u;
    if (u.indexOf('width=') > -1) return u.replace(/width=\d+/, 'width=800');
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=800';
  }

  function enhance(card) {
    if (!card || card.hasAttribute('data-qb-hover')) return;
    var raw = card.getAttribute('data-product-options');
    if (!raw) return;
    var opt;
    try { opt = JSON.parse(raw); } catch (e) { return; }
    if (!opt || !opt.image2) return;

    var inner = card.querySelector('.t4s-product-inner');
    if (!inner) return;

    var src = bigger(opt.image2);
    if (!src) return;

    card.setAttribute('data-qb-hover', '1');

    var img = document.createElement('img');
    img.className = 'qb-hover-img';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.alt = opt.alt || '';
    img.src = src;
    inner.appendChild(img);
  }

  function scan(root) {
    (root || document).querySelectorAll('.t4s-product[data-product-options]').forEach(enhance);
  }

  function start() {
    scan(document);
    if (!('MutationObserver' in window)) return;
    var mo = new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var nodes = list[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('.t4s-product[data-product-options]')) enhance(n);
          else if (n.querySelectorAll) scan(n);
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
